import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-geo-territoire-search-list',
  templateUrl: './geo-territoire-search-list.component.html',
  styleUrls: ['./geo-territoire-search-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeoTerritoireSearchListComponent implements OnInit {
  @Input() items: any;
  @Input() isAction: boolean = false;
  @Output() selected = new EventEmitter<any>();
  constructor() {}

  ngOnInit(): void {}

  onSelect(item: any): void {
    this.selected.emit(item);
  }
}
